import { ROUTER_NAME, UIPaths } from '@consts';
import { useAccountsService } from '@hooks';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

const Loader = dynamic(() => import('components/basic/Loader'), { ssr: false });

const ApprovalsGuard = ({ children }: { children: React.ReactNode }) => {
  const router = useRouter();
  const { accountMe } = useAccountsService();
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    if (!accountMe) {
      return;
    }

    // Check if approvals are required
    const needsApprovals =
      !accountMe.approvals?.privacyPolicyApproved || !accountMe.approvals?.termsOfServiceApproved;

    // If user is already on the approvals page, don't redirect
    if (router.pathname === ROUTER_NAME.APPROVALS) {
      setIsChecking(false);
      return;
    }

    // If approvals are needed, redirect to the approvals page with returnTo parameter
    if (needsApprovals) {
      // Use current path as returnTo (we know we're not on approvals page due to check above)
      router.replace(UIPaths.approvals(router.asPath));
      return;
    }

    setIsChecking(false);
  }, [accountMe, router]);

  // Allow approvals page to render without blocking
  if (router.pathname === ROUTER_NAME.APPROVALS) {
    return children;
  }

  // Show loader while checking approvals status
  if (isChecking || !accountMe) {
    return (
      <div className='w-full h-dvh'>
        <Loader />
      </div>
    );
  }

  return children;
};

export default ApprovalsGuard;
